<div class="load-panel__overlay"  *ngIf="(appService.pageLoading$ | async) || (appService.loading$ | async)" [ngClass]="{
    'load-panel__overlay--page-loading': (appService.pageLoading$ | async),
    'load-panel__overlay--app-loading': (appService.loading$ | async)
}">
</div>
<div class="load-panel__content" aria-live="assertive" [cdkTrapFocus]="(appService.pageLoading$ | async) || (appService.loading$ | async)">
    <mat-spinner color="accent" diameter="32"></mat-spinner>
    <p #loader [tabindex]="(appService.pageLoading$ | async) || (appService.loading$ | async) ? 0 : -1">{{(appService.loading$ | async) ? appService.loadingMessage : (appService.pageLoading$ | async) ? appService.pageLoadingMessage : loadedMessage}}</p>
</div>
